var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BABFCB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.698 10.52c-.067 2.017.267 3.619.559 3.91.292.293 1.901.635 3.911.56l-4.47-4.47zM9.088.227C7.145.577 5.093 1.345 3.567 2.88 2.041 4.414 1.265 6.457.915 8.4l6.363 6.364c1.952-.342 3.995-1.117 5.522-2.652 1.526-1.534 2.302-3.578 2.652-5.521L9.088.227zM6.436 10.42 5.268 9.251l4.67-4.67 1.169 1.168-4.67 4.67zM15.677 4.48c.067-2.017-.267-3.619-.559-3.91-.292-.293-1.901-.635-3.911-.56l4.47 4.47z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.6df3e7fd.svg";
export { ForwardRef as ReactComponent };